<template>
    <div>
        <!-- Customer Detail Container -->
        <div
            class="sticky-customer-card customers-info-section customer-info bg-white pt-4 rounded-lg d-flex align-items-center mb-3"
        >
            <div class="row">
                <div
                    class="col-md-3 col-sm-12 text-center profile-image-section"
                >
                    <!-- <div
                        v-if="
                            customerDetails.pictureURL != null &&
                            customerDetails.pictureURL != 'customers/no-preview.png'
                        "
                        class="customer-profile"
                    >
                        <img v-authenticated-image="customerDetails.pictureURL" />
                    </div>
                    <div v-else class="customer-profile">
                        <img
                            v-authenticated-image="`/users/blank-profile-pic.png`"
                            alt="blank profile image"
                        />
                    </div> -->
                    <base-status
                        v-if="customerDetails.status"
                        :status-type="customerDetails.status"
                    ></base-status>
                </div>
                <div class="col-md-9 col-sm-12">
                    <ul>
                        <li>
                            <div class="seprator-section">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h3
                                            v-if="
                                                localStorageTemSegment ===
                                                'Corporate'
                                            "
                                        >
                                            Company Information
                                        </h3>
                                        <h3 v-else>Customer Information</h3>
                                    </div>
                                    <div class="col-md-6">
                                        <ul class="row">
                                            <li class="col-md-6">
                                                <label>Idenfo ID:</label>
                                            </li>
                                            <li class="col-md-6">
                                                <span class="">{{
                                                    customerDetails.idenfoId
                                                }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="col-md-6">
                                        <ul class="row">
                                            <li class="col-md-6">
                                                <label>Client ID:</label>
                                            </li>
                                            <li class="col-md-6">
                                                <span class="">{{
                                                    customerDetails.clientId
                                                        ? customerDetails.clientId
                                                        : 'N/A'
                                                }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="col-md-6">
                                        <ul class="row">
                                            <li class="col-md-6">
                                                <label>Full Name:</label>
                                            </li>
                                            <li class="col-md-6">
                                                <span class="">{{
                                                    customerDetails.firstName
                                                }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div
                                        v-if="
                                            localStorageTemSegment ===
                                            'Individual'
                                        "
                                        class="col-md-6"
                                    >
                                        <ul class="row">
                                            <li class="col-md-6">
                                                <label>Father Name:</label>
                                            </li>
                                            <li class="col-md-6">
                                                <span
                                                    v-if="
                                                        customerDetails.fatherHusbandName
                                                    "
                                                    class=""
                                                    >{{
                                                        customerDetails.fatherHusbandName
                                                    }}</span
                                                >
                                                <span v-else>N/A</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div
                                        v-if="
                                            localStorageTemSegment ==
                                            'Individual'
                                        "
                                        class="col-md-6"
                                    >
                                        <ul class="row">
                                            <li class="col-md-6">
                                                <label>Gender:</label>
                                            </li>
                                            <li class="col-md-6">
                                                <span class="">{{
                                                    customerDetails.gender
                                                        ? customerDetails.gender
                                                              .title
                                                        : 'N/A'
                                                }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="col-md-6">
                                        <ul class="row">
                                            <li class="col-md-6">
                                                <label
                                                    v-if="
                                                        localStorageTemSegment ==
                                                        'Corporate'
                                                    "
                                                    >Date of Incorporation
                                                    :</label
                                                >
                                                <label v-else
                                                    >Date of Birth:</label
                                                >
                                            </li>
                                            <li class="col-md-6">
                                                <span
                                                    v-if="
                                                        customerDetails.dateOfBirth
                                                    "
                                                    >{{
                                                        customerDetails.dateOfBirth
                                                            | moment(
                                                                'D MMM, YYYY'
                                                            )
                                                    }}</span
                                                >
                                            </li>
                                        </ul>
                                    </div>
                                    <div
                                        v-if="
                                            localStorageTemSegment ==
                                            'Individual'
                                        "
                                        class="col-md-6"
                                    >
                                        <ul class="row">
                                            <li class="col-md-6">
                                                <label
                                                    >Country of
                                                    Residence:</label
                                                >
                                            </li>
                                            <li class="col-md-6">
                                                <span
                                                    :class="{
                                                        danger: customerDetails.countryOfResidenceIsSanction,
                                                    }"
                                                    >{{
                                                        customerDetails.countryOfResidence
                                                            ? customerDetails
                                                                  .countryOfResidence
                                                                  .title
                                                            : 'N/A'
                                                    }}</span
                                                >
                                            </li>
                                        </ul>
                                    </div>
                                    <div
                                        v-if="
                                            localStorageTemSegment ==
                                            'Individual'
                                        "
                                        class="col-md-6"
                                    >
                                        <ul class="row">
                                            <li class="col-md-6">
                                                <label>Citizenship:</label>
                                            </li>
                                            <li class="col-md-6">
                                                <span
                                                    :class="{
                                                        danger: customerDetails.nationalityIsSanction,
                                                    }"
                                                    >{{
                                                        customerDetails.nationality
                                                            ? customerDetails
                                                                  .nationality
                                                                  .title
                                                            : 'N/A'
                                                    }}</span
                                                >
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="col-md-6">
                                        <ul class="row">
                                            <li class="col-md-6">
                                                <label
                                                    v-if="
                                                        localStorageTemSegment ==
                                                        'Corporate'
                                                    "
                                                    >NTN NUMBER/TAX
                                                    NUMBER:</label
                                                >
                                                <label v-else
                                                    >ID Document Number</label
                                                >
                                            </li>
                                            <li class="col-md-6">
                                                <span class="">{{
                                                    customerDetails.identityInfo &&
                                                    customerDetails.identityInfo
                                                        .number
                                                        ? customerDetails
                                                              .identityInfo
                                                              .number
                                                        : 'N/A'
                                                }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div
                                        v-if="
                                            localStorageTemSegment ==
                                            'Corporate'
                                        "
                                        class="col-md-6"
                                    >
                                        <ul class="row">
                                            <li class="col-md-6">
                                                <label
                                                    >CUIN NUMBER/REGISTRATION
                                                    NUMBER:</label
                                                >
                                            </li>
                                            <li class="col-md-6">
                                                <span class="">{{
                                                    customerDetails.basicInfo &&
                                                    customerDetails.basicInfo
                                                        .CUIN
                                                        ? customerDetails
                                                              .basicInfo.CUIN
                                                        : 'N/A'
                                                }}</span>
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="col-md-6">
                                        <ul class="row">
                                            <li class="col-md-6">
                                                <label
                                                    >Record Last Updated:</label
                                                >
                                            </li>
                                            <li class="col-md-6">
                                                <span
                                                    v-if="
                                                        customerDetails.updatedAt
                                                    "
                                                    >{{
                                                        customerDetails.updatedAt
                                                            | moment(
                                                                'D MMM, YYYY'
                                                            )
                                                    }}</span
                                                >
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- Customer Detail Container End -->
        <!-- <div style="height: 334px; width:100%; ">
        </div> -->
        <!-- Top Container -->
        <div class="overflow-y">
            <div
                class="customers-info-section bg-white p-4 rounded-lg d-flex align-items-center"
            >
                <div class="row" style="width: 100%">
                    <div
                        class="col-md-3 col-sm-12 text-center profile-image-section"
                    >
                        <div class="customer-profile">
                            <img
                                :src="personEntityImage"
                                style="width: 200px; height: 200px"
                                @error="loadDefaultImage"
                            />
                            <!-- <img
                            v-else
                            :src="defaultUserIcon"
                            style="width: 200px; height: 200px"
                        /> -->
                        </div>

                        <!-- <base-status
                v-if="customerDetails.status"
                :status-type="customerDetails.status"
            ></base-status> -->
                    </div>

                    <div
                        class="col-md-9 col-sm-12 d-flex align-items-center jusitify-content-center"
                    >
                        <!-- Header right -->
                        <div style="width: 100%">
                            <!-- <div class="col-md-5 text-right">
                        <a class=""> 
                            Export Profile <span class="pdf-icon-custom"> <pdf-icon></pdf-icon> </span> 
                        </a>
                    </div> -->
                            <div class="row" style="width: 100%">
                                <div class="col-md-12">
                                    <h4 class="mb-2">
                                        {{ checkNameType(screeningData.name) }}
                                    </h4>
                                </div>
                                <div class="col-md-12">
                                    <div
                                        class="d-flex justify-content-between text-muted font-weight-bold"
                                    >
                                        <p>Profile ID</p>
                                        <p>Download</p>
                                    </div>
                                    <hr style="margin-top: -10px" />
                                </div>
                                <div
                                    class="col-md-12 d-flex justify-content-between"
                                >
                                    <p>{{ screeningData.personEntityId }}</p>
                                    <p>
                                        <a
                                            :class="[
                                                { disabled: loadingSummaryPdf },
                                            ]"
                                            @click="startDownload()"
                                        >
                                            Export Profile
                                            <span>
                                                <img
                                                    class="pdf-icon-custom d-inline"
                                                    src="@/assets/images/export-pdf.png"
                                                />
                                            </span>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- Header right End -->
                    </div>
                </div>
            </div>
            <!-- Top Container End -->

            <!-- Tabs Start  -->
            <div class="mt-4">
                <b-tabs
                    v-model="tabIndex"
                    active-nav-item-class="font-weight-bold"
                    active-tab-class="bg-white p-4"
                    content-class=""
                >
                    <b-tab :title-link-class="tabLinkClass(0)" active>
                        <template #title>
                            <h5>Profile Data</h5>
                        </template>
                        <!-- Profile Data Section start -->

                        <!-- display for SMART screening data -->
                        <div
                            v-if="screeningData.sourceList == 'Smart Search'"
                            class="pt-2 form-details"
                        >
                            <div class="row">
                                <!-- Field Start -->
                                <div
                                    class="col-md-6 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >Keywords</span
                                    >
                                    <span class="pl-2 value">{{
                                        getKeywords(screeningData.keyword) ||
                                        'N/A'
                                    }}</span>
                                </div>
                                <!-- Field End -->
                            </div>
                            <div class="row">
                                <!-- Field Start -->
                                <div
                                    class="col-md-6 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >Description</span
                                    >
                                    <span class="pl-2 value">
                                        <template
                                            v-if="
                                                screeningData.description1 &&
                                                screeningData.description1
                                                    .length < 1
                                            "
                                        >
                                            N/A</template
                                        >
                                        <ul v-else>
                                            <li
                                                v-for="desc in screeningData.description1"
                                                :key="desc.type"
                                            >
                                                <a
                                                    v-if="desc.type == 'Link'"
                                                    :href="desc.value"
                                                    target="_blank"
                                                    >Reference</a
                                                >
                                                <p v-else>{{ desc.value }}</p>
                                            </li>
                                        </ul>
                                    </span>
                                </div>
                                <!-- Field End -->
                            </div>
                            <div class="row">
                                <!-- Field Start -->
                                <div
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >Publisher Name</span
                                    >
                                    <span class="pl-2 value">
                                        {{
                                            screeningData.metadata &&
                                            screeningData.metadata
                                                .publisher_name
                                                ? screeningData.metadata
                                                      .publisher_name
                                                : screeningData.category ||
                                                  'N/A'
                                        }}
                                    </span>
                                </div>
                                <!-- Field End -->
                                <!-- Field Start -->
                                <div
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >List Name</span
                                    >
                                    <span class="pl-2 value">{{
                                        getSourceName(screeningData)
                                    }}</span>
                                </div>
                                <!-- Field End -->
                            </div>

                            <div class="row">
                                <!-- Field Start -->
                                <div
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >List Type</span
                                    >
                                    <span class="pl-2 value">{{
                                        screeningData.listType || 'N/A'
                                    }}</span>
                                </div>
                                <!-- Field End -->
                                <!-- Field Start -->
                                <div
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >List Category</span
                                    >
                                    <span class="pl-2 value">
                                        {{
                                            screeningData.listCategory || 'N/A'
                                        }}
                                    </span>
                                </div>
                                <!-- Field End -->
                            </div>
                        </div>
                        <!-- display for LIST screening data -->
                        <!-- Form Start -->
                        <div v-else class="pt-2 form-details">
                            <div class="row">
                                <!-- Field Start -->
                                <div
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >Father Name</span
                                    >
                                    <span class="pl-2 value">
                                        {{
                                            checkNull(
                                                screeningData.fathersName
                                            ) || 'N/A'
                                        }}
                                    </span>
                                </div>
                                <!-- Field End -->
                            </div>
                            <div class="row">
                                <!-- Field Start -->
                                <template
                                    v-if="
                                        screeningData.identificationType &&
                                        screeningData.identificationType
                                            .length > 0
                                    "
                                >
                                    <div
                                        v-for="(
                                            identification, index
                                        ) in screeningData.identificationType"
                                        :key="index"
                                        class="col-md-12"
                                    >
                                        <div class="d-flex">
                                            <div
                                                class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                            >
                                                <span
                                                    class="text-muted d-block label"
                                                    >ID Type
                                                    {{ index + 1 }}</span
                                                >
                                                <span class="pl-2 value">{{
                                                    checkIdType(
                                                        identification
                                                    ) || 'N/A'
                                                }}</span>
                                            </div>
                                            <!-- Field End -->

                                            <!-- Field Start -->
                                            <div
                                                class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                            >
                                                <span
                                                    class="text-muted d-block label"
                                                    >ID Number
                                                    {{ index + 1 }}</span
                                                >
                                                <span class="pl-2 value">{{
                                                    checkIdNumber(
                                                        identification
                                                    ) || 'N/A'
                                                }}</span>
                                            </div>
                                            <!-- Field End -->
                                        </div>
                                    </div>
                                </template>

                                <!-- Show N/A if no values in the array -->
                                <div v-else class="col-md-12">
                                    <div class="d-flex">
                                        <div
                                            class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                        >
                                            <span
                                                class="text-muted d-block label"
                                                >ID Type</span
                                            >
                                            <span class="pl-2 value">N/A</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <!-- Field Start -->
                                <!-- <div class="col-md-4 m-2 border-bottom border-bottom-2 field">
                    <span class="text-muted d-block label">Date of Birth</span> 
                    <span class="pl-2  value"> {{ screeningData.dob|| 'N/A' }} </span>
                </div> -->
                                <!-- Field Start -->
                                <template
                                    v-if="
                                        dateOfBirths && dateOfBirths.length > 0
                                    "
                                >
                                    <div
                                        v-for="(dob, index) in dateOfBirths"
                                        :key="index"
                                        class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                    >
                                        <span class="text-muted d-block label"
                                            >Date of Birth {{ index + 1 }}</span
                                        >
                                        <span class="pl-2 value">{{
                                            formatDate(dob.dob) || 'N/A'
                                        }}</span>
                                    </div>
                                </template>

                                <!-- Show N/A if no values in the array -->
                                <div
                                    v-else
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >Date of Birth</span
                                    >
                                    <span class="pl-2 value">N/A</span>
                                </div>
                                <!-- Field End -->
                            </div>
                            <div class="row">
                                <!-- Field Start -->
                                <template
                                    v-if="
                                        nationalityArr &&
                                        nationalityArr.length > 0
                                    "
                                >
                                    <div
                                        v-for="(
                                            nationality, index
                                        ) in nationalityArr"
                                        :key="index"
                                        class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                    >
                                        <span class="text-muted d-block label"
                                            >Nationality {{ index + 1 }}</span
                                        >
                                        <span class="pl-2 value">{{
                                            nationality.nationality || 'N/A'
                                        }}</span>
                                    </div>
                                </template>

                                <!-- Show N/A if no values in the array -->
                                <div
                                    v-else
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >Nationality</span
                                    >
                                    <span class="pl-2 value">N/A</span>
                                </div>
                                <!-- Field End -->
                            </div>

                            <div class="row">
                                <!-- Field Start -->
                                <template
                                    v-if="
                                        screeningData.alias &&
                                        screeningData.alias.length > 0
                                    "
                                >
                                    <div
                                        v-for="(
                                            alias, index
                                        ) in screeningData.alias"
                                        :key="index"
                                        class="col-md-12"
                                    >
                                        <div class="d-flex">
                                            <div
                                                class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                            >
                                                <span
                                                    class="text-muted d-block label"
                                                    >Alias Type
                                                    {{ index + 1 }}</span
                                                >
                                                <!-- <span class="badge badge-pill badge-light mr-1 custom-pill-format">{{ alias.alias_type || 'N/A' }}</span> -->
                                                <span class="pl-2 value">{{
                                                    alias.alias_type || 'N/A'
                                                }}</span>
                                            </div>
                                            <!-- Field End -->

                                            <!-- Field Start -->
                                            <div
                                                class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                            >
                                                <span
                                                    class="text-muted d-block label"
                                                    >Alias {{ index + 1 }}</span
                                                >
                                                <!-- <span class="badge badge-pill badge-success mr-1 custom-pill-format">{{ alias.alias || 'N/A' }}</span> -->
                                                <span class="pl-2 value">{{
                                                    alias.alias || 'N/A'
                                                }}</span>
                                            </div>
                                            <!-- Field End -->
                                        </div>
                                    </div>
                                </template>

                                <!-- Show N/A if no values in the array -->
                                <div v-else class="col-md-12">
                                    <div class="d-flex">
                                        <div
                                            class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                        >
                                            <span
                                                class="text-muted d-block label"
                                                >Alias Type</span
                                            >
                                            <!-- <span class="badge badge-pill badge-success mr-1 custom-pill-format">N/A</span> -->
                                            <span class="pl-2 value">N/A</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <!-- Field Start -->
                                <div
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >Gender</span
                                    >
                                    <span class="pl-2 value">
                                        <img
                                            class="mr-1 d-inline"
                                            src="@/assets/images/boy.png"
                                        />
                                        {{
                                            screeningData.gender || 'N/A'
                                        }}</span
                                    >
                                </div>
                                <!-- Field End -->
                            </div>
                            <div class="row">
                                <!-- Field Start -->
                                <div
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >Description</span
                                    >
                                    <span class="pl-2 value">
                                        {{ screeningData.desc || 'N/A' }}</span
                                    >
                                </div>
                                <!-- Field End -->
                            </div>

                            <div class="row">
                                <!-- Field Start -->
                                <div
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >Publisher Name</span
                                    >
                                    <span class="pl-2 value">
                                        {{
                                            screeningData.metadata &&
                                            screeningData.metadata
                                                .publisher_name
                                                ? screeningData.metadata
                                                      .publisher_name
                                                : screeningData.category ||
                                                  'N/A'
                                        }}
                                    </span>
                                </div>
                                <!-- Field End -->
                                <!-- Field Start -->
                                <div
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >List Name</span
                                    >
                                    <span class="pl-2 value">{{
                                        getSourceName(screeningData)
                                    }}</span>
                                </div>
                                <!-- Field End -->
                            </div>

                            <div class="row">
                                <!-- Field Start -->
                                <div
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >List Type</span
                                    >
                                    <span class="pl-2 value">{{
                                        screeningData.listType || 'N/A'
                                    }}</span>
                                </div>
                                <!-- Field End -->
                                <!-- Field Start -->
                                <div
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >List Category</span
                                    >
                                    <span class="pl-2 value">
                                        {{
                                            screeningData.listCategory || 'N/A'
                                        }}
                                    </span>
                                </div>
                                <!-- Field End -->
                                <!-- Field Start -->
                                <div
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >Source List Origin Country
                                    </span>
                                    <span class="pl-2 value">
                                        <span
                                            v-if="
                                                screeningData.metadata &&
                                                screeningData.metadata
                                                    .country != 'GL'
                                            "
                                            :class="`mb-1 fi fi-${getCountryCodeFormatted(
                                                screeningData.metadata.country
                                            )}`"
                                        ></span>
                                        <img
                                            v-else-if="
                                                screeningData.metadata &&
                                                screeningData.metadata.country
                                            "
                                            :src="GL_ICON"
                                            width="18.66"
                                            height="16.99"
                                            style="display: inline"
                                        />
                                        &nbsp;&nbsp;
                                        {{
                                            screeningData.metadata
                                                ? screeningData.metadata.country
                                                : 'N/A'
                                        }}
                                    </span>
                                </div>
                                <!-- Field End -->
                                <!-- Field Start -->
                                <div
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >Source List Description
                                    </span>
                                    <span class="pl-2 value">
                                        {{
                                            screeningData.metadata
                                                ? screeningData.metadata
                                                      .description
                                                : 'N/A'
                                        }}
                                    </span>
                                </div>
                                <!-- Field End -->
                            </div>
                        </div>
                        <!-- Form End -->

                        <!-- Profile Data Section end -->
                    </b-tab>
                    <b-tab
                        v-if="screeningData.sourceList !== 'Smart Search'"
                        :title-link-class="tabLinkClass(1)"
                    >
                        <template #title>
                            <h5>More Details</h5>
                        </template>
                        <!-- Extra Details Section Start -->
                        <!-- Form Start -->

                        <!-- display for LIST screening data -->
                        <div class="pt-2 form-details">
                            <div class="row">
                                <!-- Field Start -->
                                <div class="col-md-4 m-2 field">
                                    <span class="text-muted d-block label"
                                        >Place Of Birth</span
                                    >
                                    <span class="pl-2 value">{{
                                        checkNull(screeningData.pob) || 'N/A'
                                    }}</span>
                                </div>
                                <!-- Field End -->
                            </div>

                            <!-- Case details -->
                            <div class="row">
                                <!-- Field Start -->
                                <template
                                    v-if="
                                        screeningData.case_details &&
                                        screeningData.case_details.length > 0
                                    "
                                >
                                    <div
                                        v-for="(
                                            caseDetails, index
                                        ) in screeningData.case_details"
                                        :key="index"
                                        class="col-md-12"
                                    >
                                        <div
                                            class="col-md-6 m-2 border-bottom border-bottom-2 field"
                                        >
                                            <span
                                                class="text-muted d-block label"
                                                >Charges {{ index + 1 }}</span
                                            >
                                            <span class="pl-2 value">{{
                                                caseDetails.charges || 'N/A'
                                            }}</span>
                                        </div>
                                        <!-- Field End -->

                                        <!-- Field Start -->
                                        <div
                                            class="col-md-6 m-2 border-bottom border-bottom-2 field"
                                        >
                                            <span
                                                class="text-muted d-block label"
                                                >Case Details
                                                {{ index + 1 }}</span
                                            >
                                            <span class="pl-2 value">{{
                                                caseDetails.case_details ||
                                                'N/A'
                                            }}</span>
                                        </div>
                                        <!-- Field End -->

                                        <!-- Field Start -->
                                        <div
                                            class="col-md-6 m-2 border-bottom border-bottom-2 field"
                                        >
                                            <span
                                                class="text-muted d-block label"
                                                >Notification Reference
                                                {{ index + 1 }}</span
                                            >
                                            <span class="pl-2 value">{{
                                                caseDetails.notification_ref ||
                                                'N/A'
                                            }}</span>
                                        </div>
                                        <!-- Field End -->
                                    </div>
                                </template>

                                <!-- Show N/A if no values in the array -->
                                <div v-else class="col-md-12">
                                    <div
                                        class="col-md-6 m-2 border-bottom border-bottom-2 field"
                                    >
                                        <span class="text-muted d-block label"
                                            >Charges</span
                                        >
                                        <span class="pl-2 value">N/A</span>
                                    </div>
                                    <div
                                        class="col-md-6 m-2 border-bottom border-bottom-2 field"
                                    >
                                        <span class="text-muted d-block label"
                                            >Case Details</span
                                        >
                                        <span class="pl-2 value">N/A</span>
                                    </div>
                                    <div
                                        class="col-md-6 m-2 border-bottom border-bottom-2 field"
                                    >
                                        <span class="text-muted d-block label"
                                            >Notification Reference</span
                                        >
                                        <span class="pl-2 value">N/A</span>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <!-- Field Start -->
                                <!-- <div class="col-md-4 m-2 border-bottom border-bottom-2 field">
                    <span class="text-muted d-block label">Extra Information</span> 
                    <span class="pl-2  value">{{ screeningData.extra_info }}</span>
                </div> -->
                                <!-- Field End -->
                                <!-- Field Start -->
                                <div
                                    class="col-md-6 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >Extra Information</span
                                    >
                                    <div
                                        v-if="
                                            screeningData.extra_info &&
                                            Object.keys(
                                                screeningData.extra_info
                                            ).length !== 0
                                        "
                                    >
                                        <nested-object-display
                                            :data="screeningData.extra_info"
                                        ></nested-object-display>
                                    </div>
                                    <div v-else>
                                        <span class="pl-2 value">N/A</span>
                                    </div>
                                    <!-- <ul>
                    <li v-for="(value, key) in screeningData.extra_info" :key="key">
                        <span>{{ key }}:</span>
                        <template v-if="Array.isArray(value)">
                            {{ value.join(', ') }}
                        </template>
                        <template v-else-if="typeof value === 'object'">
                        <span>{{ JSON.stringify(value, null, 2) }}</span>
                        </template>
                        <template v-else>
                        {{ value }}
                        </template>
                    </li>
                    </ul> -->
                                </div>
                                <!-- Field End -->
                            </div>

                            <div class="row">
                                <!-- Field Start -->
                                <div
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >Head Bounty</span
                                    >
                                    <span class="pl-2 value">{{
                                        checkNull(screeningData.head_bounty) ||
                                        'N/A'
                                    }}</span>
                                </div>
                                <!-- Field End -->
                            </div>

                            <div class="row">
                                <template
                                    v-if="
                                        primaryOccupation &&
                                        primaryOccupation.length > 0
                                    "
                                >
                                    <div
                                        v-for="(
                                            occupation, index
                                        ) in primaryOccupation"
                                        :key="index"
                                        class="col-md-12"
                                    >
                                        <div class="d-flex">
                                            <div
                                                class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                            >
                                                <span
                                                    class="text-muted d-block label"
                                                    >Primary Occupation
                                                    {{ index + 1 }}</span
                                                >
                                                <span class="pl-2 value">{{
                                                    occupation || 'N/A'
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Field End -->
                                </template>

                                <!-- Show N/A if no values in the array -->
                                <div v-else class="col-md-12">
                                    <div class="d-flex">
                                        <div
                                            class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                        >
                                            <span
                                                class="text-muted d-block label"
                                                >Primary Occupation</span
                                            >
                                            <span class="pl-2 value">N/A</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Occupation details -->
                            <div class="row">
                                <!-- Field Start -->
                                <template
                                    v-if="designation && designation.length > 0"
                                >
                                    <div
                                        v-for="(role, index) in designation"
                                        :key="index"
                                        class="col-md-12"
                                    >
                                        <div class="d-flex">
                                            <!-- Field Start -->
                                            <div
                                                class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                            >
                                                <span
                                                    class="text-muted d-block label"
                                                    >Designation
                                                    {{ index + 1 }}</span
                                                >
                                                <span class="pl-2 value">{{
                                                    role.designation || 'N/A'
                                                }}</span>
                                            </div>
                                            <!-- Field End -->
                                            <!-- Field Start -->
                                            <div
                                                class="col-md-3 m-2 border-bottom border-bottom-2 field"
                                            >
                                                <span
                                                    class="text-muted d-block label"
                                                    >Start Date
                                                    {{ index + 1 }}</span
                                                >
                                                <span class="pl-2 value">{{
                                                    formatDate(
                                                        role.start_date
                                                    ) || 'N/A'
                                                }}</span>
                                            </div>
                                            <!-- Field End -->
                                            <!-- Field Start -->
                                            <div
                                                class="col-md-3 m-2 border-bottom border-bottom-2 field"
                                            >
                                                <span
                                                    class="text-muted d-block label"
                                                    >End Date
                                                    {{ index + 1 }}</span
                                                >
                                                <span class="pl-2 value">{{
                                                    roleTypeEndDate(
                                                        role.end_date
                                                    ) || 'N/A'
                                                }}</span>
                                            </div>
                                            <!-- Field End -->
                                        </div>
                                    </div>
                                </template>

                                <!-- Show N/A if no values in the array -->
                                <div v-else class="col-md-12">
                                    <div class="d-flex">
                                        <div
                                            class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                        >
                                            <span
                                                class="text-muted d-block label"
                                                >Designation</span
                                            >
                                            <span class="pl-2 value">N/A</span>
                                        </div>
                                        <div
                                            class="col-md-3 m-2 border-bottom border-bottom-2 field"
                                        >
                                            <span
                                                class="text-muted d-block label"
                                                >Start Date</span
                                            >
                                            <span class="pl-2 value">N/A</span>
                                        </div>
                                        <div
                                            class="col-md-3 m-2 border-bottom border-bottom-2 field"
                                        >
                                            <span
                                                class="text-muted d-block label"
                                                >End Date</span
                                            >
                                            <span class="pl-2 value">N/A</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Address details -->
                            <div class="row">
                                <template
                                    v-if="
                                        screeningData.address &&
                                        screeningData.address.length > 0
                                    "
                                >
                                    <div
                                        v-for="(
                                            address, index
                                        ) in screeningData.address"
                                        :key="index"
                                        class="col-md-12"
                                    >
                                        <div class="d-flex">
                                            <div
                                                class="col-md-6 m-2 border-bottom border-bottom-2 field"
                                            >
                                                <span
                                                    class="text-muted d-block label"
                                                    >Primary Address
                                                    {{ index + 1 }}</span
                                                >
                                                <span class="pl-2 value">{{
                                                    address.primary_address ||
                                                    'N/A'
                                                }}</span>
                                            </div>
                                            <!-- Field End -->
                                        </div>
                                        <div class="d-flex">
                                            <!-- Field Start -->
                                            <div
                                                class="col-md-5 m-2 border-bottom border-bottom-2 field"
                                            >
                                                <span
                                                    class="text-muted d-block label"
                                                    >Street
                                                    {{ index + 1 }}</span
                                                >
                                                <span class="pl-2 value">{{
                                                    address.street || 'N/A'
                                                }}</span>
                                            </div>
                                            <!-- Field End -->
                                        </div>
                                        <div class="d-flex">
                                            <!-- Field Start -->
                                            <div
                                                class="col-md-5 m-2 border-bottom border-bottom-2 field"
                                            >
                                                <span
                                                    class="text-muted d-block label"
                                                    >City {{ index + 1 }}</span
                                                >
                                                <span class="pl-2 value">{{
                                                    address.city || 'N/A'
                                                }}</span>
                                            </div>
                                            <!-- Field End -->
                                        </div>
                                        <div class="d-flex">
                                            <!-- Field Start -->
                                            <div
                                                class="col-md-5 m-2 border-bottom border-bottom-2 field"
                                            >
                                                <span
                                                    class="text-muted d-block label"
                                                    >State {{ index + 1 }}</span
                                                >
                                                <span class="pl-2 value">{{
                                                    address.state || 'N/A'
                                                }}</span>
                                            </div>
                                            <!-- Field End -->
                                        </div>
                                        <div class="d-flex">
                                            <!-- Field Start -->
                                            <div
                                                class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                            >
                                                <span
                                                    class="text-muted d-block label"
                                                    >Country of Residence
                                                    {{ index + 1 }}</span
                                                >
                                                <span class="pl-2 value">{{
                                                    address.country_of_residence ||
                                                    'N/A'
                                                }}</span>
                                            </div>
                                            <!-- Field End -->
                                        </div>
                                        <div class="d-flex">
                                            <!-- Field Start -->
                                            <div
                                                class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                            >
                                                <span
                                                    class="text-muted d-block label"
                                                    >ZIP {{ index + 1 }}</span
                                                >
                                                <span class="pl-2 value">{{
                                                    address.zip || 'N/A'
                                                }}</span>
                                            </div>
                                            <!-- Field End -->
                                        </div>
                                        <div class="d-flex">
                                            <!-- Field Start -->
                                            <div
                                                class="col-md-6 m-2 border-bottom border-bottom-2 field"
                                            >
                                                <span
                                                    class="text-muted d-block label"
                                                    >Other Details
                                                    {{ index + 1 }}</span
                                                >
                                                <span class="pl-2 value">{{
                                                    address.other_details ||
                                                    'N/A'
                                                }}</span>
                                            </div>
                                            <!-- Field End -->
                                        </div>
                                    </div>
                                </template>

                                <!-- Show N/A if no values in the array -->
                                <div v-else class="col-md-12">
                                    <div class="d-flex">
                                        <div
                                            class="col-md-6 m-2 border-bottom border-bottom-2 field"
                                        >
                                            <span
                                                class="text-muted d-block label"
                                                >Primary Address</span
                                            >
                                            <span class="pl-2 value">N/A</span>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <div
                                            class="col-md-5 m-2 border-bottom border-bottom-2 field"
                                        >
                                            <span
                                                class="text-muted d-block label"
                                                >Street</span
                                            >
                                            <span class="pl-2 value">N/A</span>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <div
                                            class="col-md-5 m-2 border-bottom border-bottom-2 field"
                                        >
                                            <span
                                                class="text-muted d-block label"
                                                >City</span
                                            >
                                            <span class="pl-2 value">N/A</span>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <div
                                            class="col-md-5 m-2 border-bottom border-bottom-2 field"
                                        >
                                            <span
                                                class="text-muted d-block label"
                                                >State</span
                                            >
                                            <span class="pl-2 value">N/A</span>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <div
                                            class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                        >
                                            <span
                                                class="text-muted d-block label"
                                                >Country of Residence</span
                                            >
                                            <span class="pl-2 value">N/A</span>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <div
                                            class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                        >
                                            <span
                                                class="text-muted d-block label"
                                                >ZIP</span
                                            >
                                            <span class="pl-2 value">N/A</span>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <div
                                            class="col-md-6 m-2 border-bottom border-bottom-2 field"
                                        >
                                            <span
                                                class="text-muted d-block label"
                                                >Other Details</span
                                            >
                                            <span class="pl-2 value">N/A</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Dates -->
                            <div class="row">
                                <!-- Field Start -->
                                <div
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >Date of Inclusion</span
                                    >
                                    <span class="pl-2 value">{{
                                        formatDate(
                                            screeningData.date_inclusion
                                        ) || 'N/A'
                                    }}</span>
                                </div>
                                <!-- Field End -->
                                <!-- Field Start -->
                                <div
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >Date of Exclusion</span
                                    >
                                    <span class="pl-2 value">{{
                                        formatDate(
                                            screeningData.date_exclusion
                                        ) || 'N/A'
                                    }}</span>
                                </div>
                                <!-- Field End -->
                                <!-- Field Start -->
                                <div
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >Registration Date</span
                                    >
                                    <span class="pl-2 value">{{
                                        formatDate(screeningData.reg_date) ||
                                        'N/A'
                                    }}</span>
                                </div>
                                <!-- Field End -->
                            </div>

                            <div class="row">
                                <!-- Field Start -->
                                <div
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >Deceased Dissolved Status</span
                                    >
                                    <span class="pl-2 value">
                                        <span class="d-flex">
                                            <template
                                                v-if="screeningData.deceased"
                                            >
                                                <span
                                                    class="icon-status success mr-2"
                                                    ><i class="icon-check"></i>
                                                </span>
                                                Yes
                                            </template>
                                            <template v-else>
                                                <span
                                                    class="icon-status danger mr-2"
                                                >
                                                    <i class="icon-wrong"></i>
                                                </span>
                                                No
                                            </template>
                                        </span>
                                    </span>
                                </div>
                                <!-- Field End -->
                                <!-- Field Start -->
                                <div
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >Deceased Dissolved Date</span
                                    >
                                    <span class="pl-2 value">{{
                                        formatDate(
                                            screeningData.deceased_dissolved_date
                                        ) || 'N/A'
                                    }}</span>
                                </div>
                                <!-- Field End -->
                            </div>

                            <div class="row">
                                <!-- Field Start -->
                                <div
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >Added On</span
                                    >
                                    <span class="pl-2 value">
                                        {{ formatDate(screeningData.addedOn) }}
                                    </span>
                                </div>
                                <!-- Field End -->
                                <!-- Field Start -->
                                <div
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >Updated On</span
                                    >
                                    <span class="pl-2 value">{{
                                        formatDate(screeningData.updatedOn)
                                    }}</span>
                                </div>
                                <!-- Field End -->
                            </div>

                            <div class="row">
                                <!-- Field Start -->
                                <div
                                    class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                >
                                    <span class="text-muted d-block label"
                                        >Status</span
                                    >
                                    <span class="pl-2 value">
                                        <span class="d-flex">
                                            <template
                                                v-if="screeningData.listStatus"
                                            >
                                                <span
                                                    class="icon-status success mr-2"
                                                    ><i class="icon-check"></i>
                                                </span>
                                                Active
                                            </template>
                                            <template v-else>
                                                <span
                                                    class="icon-status danger mr-2"
                                                    ><i class="icon-wrong"></i>
                                                </span>
                                                In-Active
                                            </template>
                                        </span>
                                    </span>
                                </div>
                                <!-- Field End -->
                            </div>
                        </div>
                        <!-- Form End -->

                        <!-- Extra Details Section End -->
                    </b-tab>
                    <b-tab
                        v-if="screeningData.sourceList !== 'Smart Search'"
                        :title-link-class="tabLinkClass(2)"
                        title="Relative Close Associates"
                    >
                        <template #title>
                            <h5>Relative Close Associates</h5>
                        </template>

                        <!-- Extra Details Section Start -->
                        <!-- Form Start -->
                        <div class="pt-2 form-details">
                            <div class="row">
                                <!-- Field Start -->
                                <template
                                    v-if="rcaWithName && rcaWithName.length > 0"
                                >
                                    <div
                                        v-for="(rca, index) in rcaWithName"
                                        :key="index"
                                        class="col-md-12"
                                    >
                                        <div class="d-flex">
                                            <div
                                                class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                            >
                                                <span
                                                    class="text-muted d-block label"
                                                    >Relation Type
                                                    {{ index + 1 }}</span
                                                >
                                                <span class="pl-2 value">{{
                                                    rca.relationship_type ||
                                                    'N/A'
                                                }}</span>
                                            </div>
                                            <!-- Field End -->

                                            <!-- Field Start -->
                                            <div
                                                class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                            >
                                                <span
                                                    class="text-muted d-block label"
                                                    >Relation With
                                                    {{ index + 1 }}</span
                                                >
                                                <span class="pl-2 value">{{
                                                    rca.name || 'N/A'
                                                }}</span>
                                            </div>
                                            <!-- Field End -->
                                        </div>
                                    </div>
                                </template>

                                <!-- Show N/A if no values in the array -->
                                <div v-else class="col-md-12">
                                    <div class="d-flex">
                                        <div
                                            class="col-md-4 m-2 border-bottom border-bottom-2 field"
                                        >
                                            <span
                                                class="text-muted d-block label"
                                                >Relation Type</span
                                            >
                                            <span class="pl-2 value">N/A</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Extra Details Section End -->
                    </b-tab>
                    <b-tab
                        v-if="
                            screeningData.attachments &&
                            screeningData.attachments.length > 0
                        "
                        :title-link-class="tabLinkClass(3)"
                        title="Attachments"
                    >
                        <template #title>
                            <h5>Attachments</h5>
                        </template>

                        <div class="pt-2 form-details">
                            <div class="row">
                                <div
                                    :class="[
                                        'table-section',
                                        'custom-table-width',
                                        // 'table-min-width',
                                        // 'tablet-table-min-width'
                                        // 'overflow-hidden'
                                    ]"
                                >
                                    <b-table
                                        :items="items"
                                        :fields="fields"
                                        no-local-sorting
                                        @sort-changed="sortingChanged"
                                    >
                                        <template
                                            slot="fileName"
                                            slot-scope="data"
                                        >
                                            {{ data.item.fileName }}
                                        </template>
                                        <template
                                            slot="uploadedOn"
                                            slot-scope="data"
                                        >
                                            {{ data.item.dateCreated }}
                                        </template>
                                        <template slot="size" slot-scope="data">
                                            {{ data.item.fileSize + ' KB' }}
                                        </template>
                                        <template
                                            slot="action"
                                            slot-scope="data"
                                        >
                                            <base-action
                                                icon="icon-export"
                                                label="Download"
                                                @click="
                                                    startAttachmentDownload(
                                                        data.item.fileName
                                                    )
                                                "
                                            ></base-action>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                </b-tabs>
            </div>
        </div>

        <!-- Tabs End  -->
    </div>
</template>

<script>
import GL_ICON from '@/assets/images/GL.png'
import request from '@/utils/request'
import pdfIcon from '@/components/icons/PdfIcon.vue'
import NestedObjectDisplay from '@/components/NestedObjectDisplay.vue'
import defaultUserIcon from '@/assets/images/no-preview.png'
import axios from 'axios'
const apiUrl = process.env.VUE_APP_API_URL

export default {
    components: {
        pdfIcon,
        NestedObjectDisplay,
    },
    props: {
        id: {
            // required: true,
            type: String,
        },
        hitId: {
            // required: true,
            type: String,
        },
    },

    data() {
        return {
            GL_ICON,
            fields: {
                fileName: {
                    label: 'FILE NAME',
                    sortable: true,
                    tdAttr: {
                        dataname: 'File Name',
                    },
                },
                uploadedOn: {
                    label: 'UPLOADED On',
                    sortable: true,
                    tdAttr: {
                        dataname: 'Uploaded On',
                    },
                },
                size: {
                    label: 'SIZE',
                    tdAttr: {
                        dataname: 'Size',
                    },
                    sortable: true,
                },
                action: {
                    label: 'ACTION',
                    tdAttr: {
                        dataname: 'Action',
                    },
                },
            },
            items: [],
            localStorageTemSegment: localStorage.getItem('dataSegmentType'),
            tabIndex: 0,
            customerDetails: {},
            hitDetails: {},
            dateOfBirths: [],
            nationalityArr: [],
            primaryOccupation: [],
            designation: [],
            rcaWithName: [],
            loadingSummaryPdf: false,
            entityImageExists: false,
            imgLink: false,
            defaultUserIcon: defaultUserIcon,
            isSticky: false,
        }
    },
    computed: {
        screeningData() {
            if (this.hitDetails && this.hitDetails.screeningData)
                return this.hitDetails.screeningData

            return {}
        },
        personEntityImage() {
            if (this.hitDetails && this.hitDetails.screeningData) {
                if (this.entityImageExists && this.imgLink) {
                    console.log(
                        'link img',
                        this.hitDetails.screeningData.img_tag
                    )
                    return this.hitDetails.screeningData.img_tag
                } else {
                    console.log('storage img')
                    //  return `${process.env.VUE_APP_FILE_SERVICE_URL}screeningEntity/${this.hitDetails.screeningData.img_tag}.jpg`
                    console.log(
                        'test jublee',
                        `${this.hitDetails.screeningData.img_tag}`
                    )
                    return `${process.env.VUE_APP_FILE_S3_URL}${this.hitDetails.screeningData.img_tag}.jpg`
                }
            }
            return null
        },
        fullName() {
            if (!this.customerDetails) return ''
            return (
                this.customerDetails.firstName +
                ' ' +
                this.customerDetails.middleName +
                ' ' +
                this.customerDetails.lastName
            )
        },
    },
    watch: {
        hitDetails(newValue, oldValue) {
            if (newValue && newValue.screeningData) {
                // check if entity image exists
                if (
                    this.hitDetails.screeningData.img_tag &&
                    this.isValidURL(this.hitDetails.screeningData.img_tag)
                ) {
                    this.entityImageExists = true
                    this.imgLink = true
                } else {
                    request({
                        url: `${process.env.VUE_APP_FILE_S3_URL}${newValue.screeningData.img_tag}.jpg`,
                        responseType: 'arraybuffer',
                    }).then((response) => {
                        if (response.data) {
                            this.entityImageExists = true
                        }
                    })
                }
                // check if entity image exists end
            }
        },
    },

    mounted() {
        // window.addEventListener('scroll', this.handleScroll);

        this.initializeData()
        localStorage.setItem('goBackUrl', 'screening-customer')
    }, // End of Component > computed

    methods: {
        getSourceName(screeningdata) {
            return screeningdata.metadata && screeningdata.metadata.list_name
                ? screeningdata.metadata.list_name
                : screeningdata.sourceList
                ? screeningdata.sourceList
                : 'N/A'
        },
        getCountryCodeFormatted(code) {
            if (!code) return ''
            const changed = {
                uk: 'gb',
            }
            let formatted = code.toLowerCase()
            return changed[formatted] || formatted
        },

        checkNull(item) {
            if (item && item !== null) {
                return item
            } else return 'N/A'
        },
        isValidURL(url) {
            const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i
            return urlPattern.test(url)
        },
        handleScroll() {
            const scrollPosition = window.scrollY
            // Set isSticky to true if the scroll position is greater than 200 pixels
            this.isSticky = scrollPosition > 100
        },
        loadDefaultImage(e) {
            e.target.src = this.defaultUserIcon
        },

        async initializeData() {
            this.$store.commit('showPageLoader', true)

            try {
                await this.populateCustomerData()
                await this.populateHitData()
                await this.getAttachmentsFiles()
            } catch (e) {
                console.log('error: ', e)
            }

            this.showPageLoader = false
            this.$store.commit('showPageLoader', false)
        }, // End of initializeData() method

        async populateCustomerData() {
            try {
                if (!this.id) {
                    this.id = this.$route.params.id
                }
                let { data } = await request({
                    url: `customers/${this.id}`,
                })

                this.customerDetails = data.data
                this.$store.commit('setCustomerRecord', data.data)
                this.$store.commit('setRefreshProfile', false)
            } catch (error) {
                console.log(error)
            }
        },
        async getAttachmentsFiles() {
            try {
                if (this.screeningData && this.screeningData.attachments) {
                    const { data } = await request.post('files/attachments', {
                        fileNames: this.screeningData.attachments,
                    })
                    this.items = data.fileInfos
                }
            } catch (error) {
                console.log(error)
            }
        },
        async populateHitData() {
            try {
                if (!this.hitId) {
                    this.hitId = this.$route.params.hitId
                }
                let { data } = await request({
                    url: `customers/name-screening-hit-detail/${this.hitId}`,
                })

                this.hitDetails = data.data
                this.getDob()
                this.getNationality()
                this.getRoleType()

                this.getRCAs()
            } catch (error) {
                console.log(error)
            }
        },
        getDob() {
            let oldDobs =
                this.hitDetails.screeningData.dates &&
                this.hitDetails.screeningData.dates.length
                    ? this.hitDetails.screeningData.dates
                    : []
            let newDobs =
                this.hitDetails.screeningData.dob &&
                this.hitDetails.screeningData.dob.length
                    ? this.hitDetails.screeningData.dob
                    : []

            // console.log("old dobs", oldDobs)
            // console.log("new dobs", newDobs)
            if (oldDobs && oldDobs.length) {
                for (let i = 0; i < oldDobs.length; i++) {
                    if (
                        oldDobs[i].day == 'Invalid date' ||
                        oldDobs[i].month == 'Invalid date' ||
                        oldDobs[i].year == 'Invalid date'
                    ) {
                        console.log('invalid date', oldDobs[i])
                        // this.dateOfBirths.push({})
                    } else {
                        let combinedDate =
                            oldDobs[i].day +
                            '-' +
                            oldDobs[i].month +
                            '-' +
                            oldDobs[i].year
                        console.log('combinedDate', combinedDate)
                        this.dateOfBirths.push({
                            dob: this.$moment(
                                combinedDate,
                                'DD/MM/YYYY'
                            ).format('MMM D, YYYY'),
                        })
                    }
                }
            } else if (newDobs && newDobs.length) {
                for (let i = 0; i < newDobs.length; i++) {
                    if (newDobs[i].dob) {
                        console.log(
                            'new dob',
                            this.$moment(newDobs[i].dob, 'DD/MM/YYYY').format(
                                'MMM D, YYYY'
                            )
                        )
                        this.dateOfBirths.push({
                            dob: this.$moment(
                                newDobs[i].dob,
                                'DD/MM/YYYY'
                            ).format('MMM D, YYYY'),
                        })
                    } else {
                        // this.dateOfBirths.push({})
                    }
                }
            } else {
                this.dateOfBirths = []
            }
        },
        getNationality() {
            let oldNation =
                this.hitDetails.screeningData.country &&
                this.hitDetails.screeningData.country.length
                    ? this.hitDetails.screeningData.country
                    : []
            let newNation =
                this.hitDetails.screeningData.nationality &&
                this.hitDetails.screeningData.nationality.length
                    ? this.hitDetails.screeningData.nationality
                    : []

            // console.log("old nationa", oldNation)
            // console.log("new nationa", newNation)

            if (oldNation && oldNation.length) {
                if (oldNation[0].type == 'Citizenship' && oldNation[0].name) {
                    this.nationalityArr.push({ nationality: oldNation[0].name })
                } else {
                    console.log('type not matched')
                }
            } else if (newNation && newNation.length) {
                for (let i = 0; i < newNation.length; i++) {
                    if (newNation[i].nationality) {
                        this.nationalityArr.push({
                            nationality: newNation[i].nationality,
                        })
                    } else {
                        console.log('not exist')
                    }
                }
            } else {
                this.nationalityArr = []
            }
        },
        async getRCAs() {
            let rca = this.screeningData.rca
            console.log('rca', rca)

            if (rca && rca.length) {
                let relationWith = rca.map((item) => item.relation_with)
                console.log('relation with array iDS', relationWith)

                await axios
                    .post(
                        apiUrl + 'customers/rca',
                        { relations: relationWith },
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${localStorage.getItem(
                                    'vueauth_token'
                                )}`,
                            },
                        }
                    )
                    .then((response) => {
                        console.log('response getRca', response.data.data)
                        for (const relationship of rca) {
                            const matchingPerson = response.data.data.find(
                                (person) =>
                                    person.personEntityId ===
                                    relationship.relation_with
                            )
                            if (matchingPerson) {
                                this.rcaWithName.push({
                                    name: matchingPerson.name,
                                    relationship_type:
                                        relationship.relationship_type,
                                })
                            }
                        }
                        console.log('rcaWithName array', this.rcaWithName)
                    })
                    .catch(() => console.log('error occured'))
            }
        },
        getRoleType() {
            let roleTypeArr = this.hitDetails.screeningData.role_type
            if (roleTypeArr && roleTypeArr.length) {
                this.primaryOccupation = roleTypeArr
                    .filter((item) => item.primary_occupation !== '')
                    .map((item) => item.primary_occupation)
                this.designation = roleTypeArr
                    .filter((item) => item.designation !== '')
                    .map((item) => {
                        return {
                            designation: item.designation,
                            start_date: item.start_date,
                            end_date: item.end_date,
                        }
                    })
                // console.log('primary occupateion arry', this.primaryOccupation)
                // console.log('designation arry', this.designation)
            }
        },
        formatDate(date) {
            if (date && date !== null) {
                return this.$moment(date).format('MMM DD, YYYY')
            }
            return 'N/A'
        },
        roleTypeEndDate(date) {
            if (date) {
                console.log('role type end date: ', date, typeof date)
                let presentDate =
                    this.$moment('1890-01-01').format('DD/MM/YYYY')
                let formattedDate = this.$moment(date).format('DD/MM/YYYY')
                // console.log("formatted role type end date: ",presentDate, formattedDate)
                if (formattedDate == presentDate) {
                    console.log('end date is present')
                    return 'Present'
                } else {
                    // console.log("else: ", this.formatDate(date))
                    return this.formatDate(date)
                }
            }
        },
        getKeywords(keywordArr) {
            console.log('keyword array', keywordArr)
            if (keywordArr && keywordArr.length) {
                let unescapedJson = keywordArr[0].replace(/\\/g, '')
                let jsonData = JSON.parse(unescapedJson)

                let words = Object.keys(jsonData).join(', ')
                console.log('keywords', words)
                return words
            } else {
                return 'N/A'
            }
        },
        checkNameType(name) {
            if (typeof name == 'string') {
                return name
            } else if (typeof name == 'object' && Array.isArray(name)) {
                return name[0].firstName
            } else {
                return 'N/A'
            }
        },
        checkIdType(idType) {
            if (Object.keys(idType).includes('type')) {
                return idType.type
            } else if (Object.keys(idType).includes('id_type')) {
                return idType.id_type
            }
        },
        checkIdNumber(idNumber) {
            if (Object.keys(idNumber).includes('value')) {
                return idNumber.value
            } else if (Object.keys(idNumber).includes('id_number')) {
                return idNumber.id_number
            }
        },
        tabLinkClass(index) {
            if (this.tabIndex === index) {
                return [
                    'font-weight-bold',
                    'text-dark',
                    'tabHeading',
                    'w-210',
                    'text-center',
                ]
            } else {
                return [
                    'bg-light',
                    'text-dark',
                    'tabHeading',
                    'w-210',
                    'text-center',
                ]
            }
        },
        startAttachmentDownload(fileName) {
            axios({
                method: 'get',
                url: `${process.env.VUE_APP_FILE_SERVICE_URL}attachments/${fileName}`,
                responseType: 'blob',
                // headers: headers,
            })
                .then((response) => {
                    this.forceFileDownload(response)
                })
                .catch(() =>
                    console.log('error occured in attachment file download')
                )
        },
        startDownload() {
            console.log('This is my current customer', this.customerDetails)
            console.log(
                'This is my current hit ID:',
                this.screeningData.personEntityId
            )
            // this.$store.commit('setLoading', true)
            this.loadingSummaryPdf = true
            axios({
                method: 'get',
                url: `${process.env.VUE_APP_API_URL}customers/generateHitReport/${this.customerDetails._id}/${this.hitDetails._id}`,
                responseType: 'blob',
            })
                .then((response) => {
                    console.log('hello I am repsonse:', response)
                    this.forceFileDownload(response)
                })
                .catch(() => console.log('error occured'))
        },

        forceFileDownload(response) {
            console.log('This is the response:', response)
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute(
                'download',
                `summary-report-${this.screeningData.personEntityId}.pdf`
            )
            document.body.appendChild(link)
            console.log('link:', link)
            link.click()
            // this.$store.commit('setLoading', false)
            this.loadingSummaryPdf = false
        },
    },
}
</script>

<style>
p {
    font-size: 14px;
}

.tabHeading {
    text-decoration: none !important;
    font-size: 15px !important;
    padding-top: 12px;
}

.badge-light {
    background-color: lightgray;
}

.badge-success {
    background-color: #8dcd83;
    color: white;
}

.value {
    font-weight: 600;
    display: inline-block;
}

.icon-custom {
    display: inline-flex;
}

.field,
.field .label {
    padding-bottom: 10px;
}

.icon-status {
    width: 24px;
    height: 24px;
    border-radius: 100%;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: relative;
    top: -5px;
}

span.icon-status i {
    color: #fff;
    font-size: 12px;
}

span.icon-status.success {
    background-color: #00c535;
}

span.icon-status.danger {
    background-color: #c91f37;
}

.badge-pill {
    font-size: 14px;
    padding: 4px 12px;
}

.pdf-icon-custom div {
    width: 26px;
    display: inline-block;
    margin-left: 10px;
}

.border-bottom-2 {
    border-bottom-width: 2px !important;
}

.custom-pill-format {
    display: block;
    width: fit-content;
    margin-bottom: 3px;
}

.border-bottom-custom-1 {
    border-bottom: #695b5b 2px solid;
}

.customers-info-section {
    min-height: 254px;
}

.w-210 {
    min-width: 210px;
    width: fit-content;
}

.form-details .col-md-4,
.form-details .col-md-5,
.form-details .col-md-6,
.form-details .col-md-12 {
    padding-left: 0px;
}

.customers-info-section ul li {
    list-style-type: none;
}

.customer-info img {
    min-width: 60%;
    margin-left: auto;
    margin-right: auto;
}

.sticky-customer-card {
    top: 52px;
    position: sticky;
    background: white;
    z-index: 1;
    border-bottom: 1px rgba(99, 99, 99, 0.2);
    border-radius: 0px !important;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}

.custom-table-width {
    min-width: 60rem;
}
</style>
